import { render, staticRenderFns } from "./BTN016n_right.vue?vue&type=template&id=1ecec878&scoped=true&"
import script from "./BTN016n_right.vue?vue&type=script&lang=js&"
export * from "./BTN016n_right.vue?vue&type=script&lang=js&"
import style0 from "./BTN016n_right.vue?vue&type=style&index=0&id=1ecec878&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ecec878",
  null
  
)

export default component.exports